import * as XLSX from 'xlsx';
import { indications } from "./indications";
import { offers } from "./offers";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function toLogin(error, router) {
	// Verifica se o erro e a resposta existem
	const status = error?.response?.status || error?.status || null;
	const errorCode = error?.code || "";

	console.warn("[toLogin] Erro detectado:", {
		status,
		message: error?.message,
		code: errorCode,
		url: error?.config?.url,
	});

	// Caso o erro seja 403 (não autorizado)
	if (status === 403) {
		console.info("[toLogin] Redirecionando para login por status 403");
		router.push("/");
		return;
	}

	// Caso o erro seja de rede (sem resposta do servidor)
	if (errorCode === "ERR_NETWORK") {
		console.error(
			"[toLogin] Erro de rede detectado. Verifique a conexão ou CORS."
		);
		// Aqui você poderia redirecionar ou exibir alerta
		router.push("/");
		return;
	}

	// Outros erros não tratados
	console.error("[toLogin] Erro não tratado:", error);
}

function getMask(type) {
	if (type === "cep") {
		return "#####-###";
	}

	if (type === "cnpj") {
		return "##.###.###/####-##";
	}

	if (type === "cpf") {
		return "###.###.###-##";
	}

	if (type === "whatsapp") {
		return "(##) #####-####";
	}

	if (type === "fixo") {
		return "(##) ####-####";
	}

	if (type === "dn") {
		return "##/##/####";
	}

	if (type === "monthYear") {
		return "##/####";
	}
}

function validateCep(cep) {
	const regex = /^[0-9]{5}-?[0-9]{3}$/;
	return regex.test(cep);
}

function validatePhone(phone) {
	const regex = /^\(?\d{2}\)?[\s-]?\d{4,5}-?\d{4}$/;
	return regex.test(phone);
}

function validateCreateUser(email, confirmEmail, password, confirmPassword) {
	if (!email || !confirmEmail) {
		return "Os campos de E-mail e Confirmação de E-mail não podem estar vazios.";
	}

	if (email !== confirmEmail) {
		return "Os campos de E-mail devem ser idênticos.";
	}

	if (!password || !confirmPassword) {
		return "Os campos de Senha e Confirmação de Senha não podem estar vazios.";
	}

	if (password !== confirmPassword) {
		return "Os campos de Senha devem ser idênticos.";
	}

	return true;
}

async function checkEmailExists(email) {
	try {
		if (!email) {
			return "Necessário passar um E-mail para verificação.";
		}

		const response = await offers.exists({ email: email });
		return response.data.exists;
	} catch (error) {
		console.error(
			"Não foi possível verificar se o e-mail já existe na base de dados: ",
			error
		);
	}
}

function formatCurrency(value) {
	return new Intl.NumberFormat("pt-Br", {
		style: "currency",
		currency: "BRL",
	}).format(value || 0);
}

function validateEmail(email) {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	if (!emailRegex.test(email)) {
		return false;
	}
	return true;
}

function validatePassword(password) {
	const passwordRegex =
		/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
	if (!passwordRegex.test(password)) {
		return false;
	}
	return true;
}

async function openFileImport() {
	try {
		await offers.downloadFileModel();
		return { success: true };
	} catch (error) {
		const err = `Erro ao abrir arquivo: ${error?.message}`;
		console.error(err);
		return {
			success: false,
			message: err || "Erro desconhecido ao tentar abrir o arquivo.",
		};
	}
}

function formatDocument(document) {
	if (!document) return "";
	let cleanCpf = document.replace(/\D/g, "").padStart(11, "0");
	if (cleanCpf.length === 11) {
		return cleanCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
	}
	return cleanCpf;
}

function validateString(value) {
	if (value == null) return "";
	return typeof value === "string" ? value : String(value);
}

function extractErrorMessage(error, fallback = "Erro ao fazer a requisição") {
	const status = error?.response?.status || error?.status || null;

	if (status === 403) {
		setTimeout(() => {
			window.location.assign("/");
		}, 2000);
		return "Sua sessão expirou. Por favor, faça login novamente para continuar.";
	}

    if (status === 500) {
        return 'Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.';
    }

	if (error?.response?.data?.message) return error.response.data.message;
	if (error?.message) {
		if (error.message.includes("Invalid request")) {
			return "Requisição inválida. Verifique os dados e tente novamente.";
		}
        if(error.message.includes('Network Error')){

			return 'Erro de rede. Verifique sua conexão.';
		}
		return error.message;
	}
	return fallback;
}

function makePassword(document) {
	const partialDocument = document?.replace(/\D/g, "").substring(0, 4);
	return `Vcp${partialDocument}@`;
}

function makeRawPhone(phone) {
	const rawPhone = phone
		.replace(/\D/g, "")
		.replace(/^(\d{2})(\d)(\d{4})(\d{4})$/, "$2-$3-$4")
		.replaceAll("-", "");
	const rawPhoneCode = phone.match(/\((\d+)\)/)[1];
	return { phone: rawPhone, phone_code: rawPhoneCode };
}

function formatPhoneNumber(phone) {
	if (!phone) return "";
	const cleaned = phone.replace(/\D/g, "");
	const match =
		cleaned.match(/^(\d{2})(\d{5})(\d{4})$/) ||
		cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
	if (match) {
		return `(${match[1]}) ${match[2]}-${match[3]}`;
	}
	return phone;
}

function sumTotals(plans = [], key) {
	return plans.reduce((acc, plan) => acc + (plan[key] || 0), 0);
}

function serialize(params = {}) {
	const validParams = {};

	Object.entries(params).forEach(([key, value]) => {
		// Verifica se o valor é válido (não é null, undefined, string vazia, etc.)
		if (value !== null && value !== undefined && value !== "") {
			validParams[key] = value;
		}
	});

	// Se não há parâmetros válidos, retorna string vazia
	if (Object.keys(validParams).length === 0) {
		return "";
	}

	// Converte o objeto em query string
	const queryString = Object.entries(validParams)
		.map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
		.join("&");

	return `?${queryString}`;
}

function normalizeDate(dateStr) {
	const s = String(dateStr || "").trim();
	const regexFull = /^\d{2}\/\d{2}\/\d{4}$/; // dd/mm/aaaa
	const regexMonthYear = /^\d{2}\/\d{4}$/; // mm/aaaa
	if (regexFull.test(s)) return s;
	if (regexMonthYear.test(s)) return `01/${s}`;
	throw new Error("Formato de data inválido. Use dd/mm/aaaa ou mm/aaaa.");
}

function validateDateBasic(dateStr, minYear = 1900) {
	const [dayStr, monthStr, yearStr] = String(dateStr).split("/");
	const day = Number(dayStr),
		month = Number(monthStr),
		year = Number(yearStr);

	if ([day, month, year].some(Number.isNaN)) {
		throw new Error("Data inválida. Use números no formato DD/MM/AAAA");
	}
	if (yearStr.length !== 4 || year < minYear) {
		throw new Error(`Ano inválido. Deve ter 4 dígitos e ser ≥ ${minYear}`);
	}
	if (month < 1 || month > 12) {
		throw new Error("Mês inválido (1–12)");
	}
	const daysInMonth = new Date(year, month, 0).getDate();
	if (day < 1 || day > daysInMonth) {
		throw new Error(
			`Dia inválido para o mês. Este mês tem ${daysInMonth} dias`
		);
	}
	return { day, month, year };
}

function validateFutureDate(dateStr, dateType) {
	const normalized = normalizeDate(dateStr);
	const { day, month, year } = validateDateBasic(normalized);

	const inputDate = new Date(year, month - 1, day);

	const today = new Date();
	today.setHours(0, 0, 0, 0);

	if (dateType === "month") {
		const inputYM = year * 12 + (month - 1);
		const currentYM = today.getFullYear() * 12 + today.getMonth();
		if (inputYM <= currentYM) {
			throw new Error("Mês de reajuste inválido");
		}
	} else {
		if (inputDate < today) {
			throw new Error(
				`Data de vigência inválida: ${normalized}. Não pode ser menor que hoje`
			);
		}
	}
	return normalized;
}

function formatTitle(title) {
	const name = title?.replace(/_/g, " ") || "";
	const formatted = name
		.toLowerCase()
		.replace(/\b\w/g, (char) => char.toUpperCase());
	return formatted;
}

function formatCreatedAt(createdAt) {
	if (!createdAt || typeof createdAt !== "string") return "—";
	const [y, m, d] = createdAt.split("T")[0].split("-");
	return `${d}/${m}/${y}`;
}

function formatStatus(status) {
	switch (status) {
		case "pending":
			return {
				text: "Pendente",
				color: "#FFA500",
				icon: "clock",
			};
		case "paid":
			return {
				text: "Pago",
				color: "#28a745",
				icon: "check-circle-fill",
			};
		default:
			return {
				text: status,
				color: "#6c757d",
				icon: "question-circle-fill",
			};
	}
}

function extractFileExtension(filename) {
	return filename.split(".").pop().toLowerCase();
}

function validateExtensionFile(avatarFile, supportedExtensions) {
	const fileExtension = extractFileExtension(avatarFile?.name || "");

	if (!supportedExtensions.includes(fileExtension)) {
		return false;
	}

	return true;
}

async function getAvatarUploadUrl(userId, extensionName) {
	const payload = {
		userId: userId,
		fileExtension: extensionName,
	};
	const { data } = await indications.uploadURL(payload);

	if (!data) {
		throw new Error("Falha ao obter URL de upload do avatar.");
	}
	return data;
}

async function uploadFileToUrl(uploadUrl, avatarFile) {
	const uploadResponse = await fetch(uploadUrl, {
		method: "PUT",
		headers: {
			"Content-Type": avatarFile?.type,
		},
		body: avatarFile,
	});
	if (!uploadResponse.ok) {
		throw new Error("Falha ao fazer upload do arquivo.");
	}
}

async function checkFile(key) {
	const checkResponse = await indications.checkFile(key);

	if (!checkResponse?.data?.exists) {
		throw new Error("Comprovante não encontrado após upload. Tente novamente.");
	}
}

function nonAllOptions(object, value) {
	if (!object || !Array.isArray(object)) return [];
	return object.filter(option => option.value !== value);
}

function createAndExportXlsxFile(data, filename) {
	const worksheet = XLSX.utils.json_to_sheet(data);
	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');
	XLSX.writeFile(workbook, `${filename}_${Date.now()}.xlsx`);
}

export {
	checkEmailExists, checkFile, createAndExportXlsxFile, delay,
	extractErrorMessage,
	extractFileExtension,
	formatCreatedAt,
	formatCurrency,
	formatDocument,
	formatPhoneNumber,
	formatStatus,
	formatTitle, getAvatarUploadUrl,
	getMask,
	makePassword,
	makeRawPhone, nonAllOptions, normalizeDate,
	openFileImport,
	serialize,
	sumTotals,
	toLogin,
	uploadFileToUrl,
	validateCep,
	validateCreateUser,
	validateDateBasic,
	validateEmail,
	validateExtensionFile,
	validateFutureDate,
	validatePassword,
	validatePhone,
	validateString
};

